import React from 'react';
import PropTypes from 'prop-types';
import { TouchableOpacity, Alert, View } from 'react-native';

import {findIndex} from 'lodash';
import { ref } from '@dbk-legacy/muster/utils';
import DonutChart from '../../../../common/components/donut-chart';
import SimpleBarChart from "../../../../components/common/simpleChart";

import createChartData from '../../../../common/components/donut-chart/donut-chart-data';
import PortfolioChartLegend from '../../../../common/components/portfolio/legend/legend';
import ResponsiveDimensionValues from '../../../../components/common/responsive-dimension-values';

import { pure } from '@dbk/ui-react-utils';

import { createContainer } from '@dbk-legacy/muster/react';

import styles, { chartSVGStyles, getAdaptiveWidth } from './portfolio-circular-chart.styles';

import { getAssets, hasNegativeAssets } from '../../../../common/components/portfolio/utils';
import { getAssetClassChartData } from '../../../../utils/get-chart-data-screen-reader';
function PortfolioCircularChart(props) {

  const propValues = props;
  const {
    portfolio: {
      id,
      selectedChartAsset,
      chartAssets = [],
    },
    setAssetClassName,
    portfolios,
    selectedPortfolioData,
    changePortfolio,
    changePortfolioData,
    clearData,
    changePage,
    currency,
    toggleLegend,
    selectedPorfolioItem,
    showLegend,
    i18n: {messages},
    auth: {langCode, channel},
    onCircularBarClick,
    rsa: {
      rsaAuthorised,
    },
    setRsaPageName,
    screen: {
      width,
      height,
      isSmall,
    },
  } = props;

  const handleCategoryLinkPressed = (categoryId) => {
    if (selectedPortfolioData.relId != null){
      alert(messages['app.portfolio.circularChart.selPort']);
    } else {
      setAssetClassName(categoryId);
      setRsaPageName(categoryId);
      if (rsaAuthorised === undefined || rsaAuthorised === false) {
        propValues.rsa.onChangePage(`/portfolios/${categoryId}`);
      } else {
        changePage({ pathname: `/portfolios/${categoryId}` });
      }
    }
  }

  const handleSelected = (index) => {
    if (props.onCircularBarClick) {
      props.onCircularBarClick(index, barsDonut[index]);
    }
  };

  const getScreenReaderData = (barsDonut) => {
    const msgObj = { graphDesc: messages['app.accessibility.chart.assetClass'],
        marketValueMsg: messages['app.portfolio.listassets.mktValue'],
        percentMsg: messages['app.accessibility.chart.percent']
    }
    const screenReaderChartData = getAssetClassChartData(msgObj,
      barsDonut)
    return { ...screenReaderChartData };
  };

  const barsDonut = getAssets(chartAssets, selectedPorfolioItem);
  const showBarChart = hasNegativeAssets(barsDonut);
  // const showBarChart = false;

  const chartPadding = chartSVGStyles.root.padding;
  const adaptiveWidth = getAdaptiveWidth(width, !isSmall);
  const formatter = new Intl.NumberFormat(langCode);

  return (
    <View style={styles.root} testID="portfolio-chart" className='portfolio-chart'  accessible={true} tabIndex={0} {...getScreenReaderData(barsDonut)}>
      <View style={[styles.wrapper, {width: adaptiveWidth - chartPadding}]}>
     {!showBarChart ? <DonutChart
          onSelectedItem={handleSelected}
          items={createChartData(barsDonut)}
          loading={false}
          formatValue={({ displayPercent }) => {
            if (displayPercent === null) return '';
            return `${formatter.format(displayPercent)}%`;
          }}
          // renderSelectedItem={renderSelectedItem}
          DonutChartPreloader={(props) => (
            props.loading
              ? <span>Loading</span>
              : null
          )}
        /> :
          <SimpleBarChart
            // xTickFormater = {(i) => `${truncateText(barsDonut[i].name, 6)}`}
            xTickFormater={(i) => `${(barsDonut[i].value / 1000000).toFixed(2)}mn`}
            yTickFormater={(value) => `${value / 1000000}mn`}
            hasxAxis={false}
            hasyAxis={false}
            hasGrid={false}
            newHeight={ResponsiveDimensionValues.windowHeight * 0.5}
            showSelected
            hasCustomInteractions
            bars={barsDonut}
            onSelectedItem={handleSelected}
            selectedInteractionValue={selectedPortfolioData}
            onInteractionChange={handleSelected}
            messages={messages}
          />
        }
        <PortfolioChartLegend
          showLegend
          // toggleLegend={toggleLegend}
          messages={messages}
          items={barsDonut}
          channel={channel}
        />
      </View>
    </View>
  );
}

PortfolioCircularChart.propTypes = {
  portfolio: PropTypes.shape({
    id: PropTypes.string.isRequired,
    chartAssets: PropTypes.arrayOf(PropTypes.shape({
      category: PropTypes.shape({
        id: PropTypes.string,
        name: PropTypes.string,
      }),
      marketValue: PropTypes.shape({
        value: PropTypes.number,
      }),
    })),
    selectedChartAsset: PropTypes.shape({
      category: PropTypes.shape({
        id: PropTypes.string.isRequired,
        name: PropTypes.string,
      }),
      marketValue: PropTypes.shape({
        value: PropTypes.number.isRequired,
      }).isRequired,
    }).isRequired,
  }).isRequired,
  selectedPortfolioData: PropTypes.object,
  portfoliosData: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    relId: PropTypes.string,
  })),
  currency: PropTypes.string.isRequired,
  portfolios: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
  })).isRequired,
  changePage: PropTypes.func.isRequired,
  changePortfolio: PropTypes.func.isRequired,
  changePortfolioData: PropTypes.func,
  onDragStart: PropTypes.func,
  onDragMove: PropTypes.func,
  onDragEnd: PropTypes.func,
  onChangePage: PropTypes.func,
  toggleLegend: PropTypes.func,

  setRsaPageName: PropTypes.func.isRequired,
  deviceInfo: PropTypes.object,
  showLegend: PropTypes.bool,
};

PortfolioCircularChart.defaultProps = {
  showLegend: false,
};

PortfolioCircularChart.contextTypes = {
  call: PropTypes.func,
};

export default createContainer({
  $fragments: {
    portfolio: {
      id: true,
      chartAssets: {
        $type: 'list',
        $range: {
          offset: 0,
          length: ref('portfolio.assets.length'),
        },
        $node: {
          category: {
            id: true,
            name: true,
          },
          marketValue: {
            value: true,
          },
          allocation: {
            value: true,
          },
          dayChange: {
            percent: true,
            value: true,
          },
        },
        clearData: {$call: 'portfolio.clearData'},
      },
      selectedChartAsset: {
        category: {
          id: true,
          name: true,
        },
        marketValue: {
          value: true,
        },
      },
    },
    portfolios: true,
  },
  $queries: {
    rsa: {
      rsaAuthorised: true,
      onChangePage: {$call: 'changePage'},
    },
    i18n: {
      messages: true,
    },
    auth : {
      langCode: true,
      channel:  true,
    },
    setAssetClassName: {$set: 'portfolio.assetClassName'},
    setRsaPageName: {$set: 'ui.state.rsaPageName'},
    screen: {
      width: true,
      height: true,
      isSmall: true,
    },
  },
})(pure(PortfolioCircularChart));

export { PortfolioCircularChart };
